module.exports = __webpack_public_path__ + "img/swiper2-1.fa2573c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/findUs/swiper2-1.jpg
// module id = 354
// module chunks = 0